import * as Yup from "yup";

export const trainerVoiceSchema = Yup.object().shape({
  name: Yup.string().required("Trainer name is required"),
  phone: Yup.string()
    .max(25, "cannot be > 25 digits")
    .required("Please enter valid phone number"),
  email: Yup.string()
    .email("Please enter valid Username i.e email")
    .max(50, "Email cannot be greater than 50 characters")
    .required("Username is required"),
  gender: Yup.string().required("Gender is required"),
  canLive: Yup.string().required("Status is required"),
  qualifications: Yup.array().max(8),
});
